import React from "react";
import { useOverlayContext } from "../OverlayContext";
import { getTopmostBlockingIndex } from "../overlayStackUtils";

/**
 * Проверяет, есть ли в overlay-стеке активная modal (blocking) surface.
 *
 * @returns `true`, если topmost blocking overlay перекрывает нижний стек
 */
export function useHasTopmostBlockingOverlay(): boolean {
    const { entries } = useOverlayContext();

    return React.useMemo(() => getTopmostBlockingIndex(entries) !== -1, [entries]);
}
